module.exports = __webpack_public_path__ + "media/ko_kr_s4_MinJung.8a7a0685.oga";